/* Version: 3.5.155 */
'use client';
import _extends from '@babel/runtime/helpers/extends';
import { DROPDOWN_VARIANT } from './constants.js';
import Dropdown$1 from './Dropdown.js';

var Dropdown = _extends(Dropdown$1, {
  VARIANT: DROPDOWN_VARIANT,
  reduxFormProps: {
    inputProp: 'value',
    inputType: 'string'
  }
});

export { DROPDOWN_VARIANT, Dropdown as default };
